import {storeConstants} from '../constants';
import {storeServiceNode} from '../services';
import {parseErrorApi} from "../services/http";
import {alertActions} from './alertAction';

export const storeActions = {
    create,
    update,
    getOne,
    del,
    clear,
    toggleProfile,
}

function create(store) {
    return dispatch => {
        storeServiceNode.create(store)
            .then(
                data => {
                    dispatch(alertActions.success('Create the Store successful!'));
                    dispatch(success(data));
                },
                error => {
                    dispatch(alertActions.error(parseErrorApi(error)));
                    dispatch(failure(error));
                }
            );
    };
    function success(store) { return {type: storeConstants.CREATE_SUCCESS, store} }
    function failure(error) { return {type: storeConstants.CREATE_FAILURE, error} }
}


function update(store) {
    return dispatch => {
        storeServiceNode.update(store)
            .then(
                data => {
                    dispatch(success(store));
                    dispatch(alertActions.success('Update the Store successful'));
                },
                error => {
                    dispatch(alertActions.error(parseErrorApi(error)));
                    dispatch(failure(error));
                }
            );
    }

    function success(store) { return {type: storeConstants.UPDATE_SUCCESS, store} }
    function failure(error) { return {type: storeConstants.UPDATE_FAILURE, error} }
}


function getOne(id) {
    return dispatch => {
        storeServiceNode.get(id)
            .then(
                store => {
                    dispatch(success(store));
                },
                error => {
                    dispatch(alertActions.error(parseErrorApi(error)));
                    dispatch(failure(error));
                }
            );
    };

    function success(store) { return {type: storeConstants.GETONE_SUCCESS, store} }
    function failure(error) { return {type: storeConstants.GETONE_FAILURE, error} }
}


function del(id) {
    return dispatch => {
        storeServiceNode.del(id)
            .then(
                res => {
                    dispatch(alertActions.success('Delete the Store successful'));
                },
                error => {
                    dispatch(alertActions.error(parseErrorApi(error)));
                    dispatch(failure(error));
                }
            );
    };
    function failure(error) { return {type: storeConstants.DELETE_FAILURE, error} }
}

function clear() {
    return { type: storeConstants.CLEAR };
}


/**
 * Use for web-checkin app
 */
function toggleProfile(toggle) {
    return dispatch => {
        dispatch({type: storeConstants.TOGGER_PROFILE, toggle: toggle});
    };
}
